/**
 * Tailorability hub API — `/tailorability/*` (Plan Faz 11).
 */
export class TailorabilityApi {
    constructor(client) {
        this.client = client;
        this.basePath = '/tailorability';
    }

    _get(path) { return this.client.get(`${this.basePath}${path}`).then((r) => r.data); }

    _post(path, body) { return this.client.post(`${this.basePath}${path}`, body).then((r) => r.data); }

    _put(path, body) { return this.client.put(`${this.basePath}${path}`, body).then((r) => r.data); }

    _delete(path) { return this.client.delete(`${this.basePath}${path}`).then((r) => r.data); }

    // Custom fields
    listCustomFields(params) { return this._get('/custom-fields'); }
    getCustomFieldById(id) { return this._get(`/custom-fields/${id}`); }
    createCustomField(body) { return this._post('/custom-fields', body); }
    updateCustomField(id, body) { return this._put(`/custom-fields/${id}`, body); }
    deleteCustomField(id) { return this._delete(`/custom-fields/${id}`); }
    customFieldsByEntity(entityType) { return this._get(`/custom-fields/by-entity/${entityType}`); }

    // Form layouts
    listFormLayouts() { return this._get('/form-layouts'); }
    getFormLayoutById(id) { return this._get(`/form-layouts/${id}`); }
    createFormLayout(body) { return this._post('/form-layouts', body); }
    updateFormLayout(id, body) { return this._put(`/form-layouts/${id}`, body); }
    deleteFormLayout(id) { return this._delete(`/form-layouts/${id}`); }
    formLayoutsByEntity(entityType, params = {}) {
        const qs = new URLSearchParams();
        if (params.mode) qs.set('mode', String(params.mode));
        const suffix = qs.toString() ? `?${qs.toString()}` : '';
        return this._get(`/form-layouts/by-entity/${entityType}${suffix}`);
    }

    // Custom permissions
    listCustomPermissions() { return this._get('/custom-permissions'); }
    getCustomPermissionById(id) { return this._get(`/custom-permissions/${id}`); }
    createCustomPermission(body) { return this._post('/custom-permissions', body); }
    updateCustomPermission(id, body) { return this._put(`/custom-permissions/${id}`, body); }
    deleteCustomPermission(id) { return this._delete(`/custom-permissions/${id}`); }

    // Branding / flags
    getBranding() { return this._get('/branding'); }
    upsertBranding(body) { return this._put('/branding', body); }
    listFeatureFlags() { return this._get('/feature-flags'); }
    upsertFeatureFlag(body) { return this._put('/feature-flags', body); }
}
